"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSTS = void 0;
const CONSTS = exports.CONSTS = Object.freeze({
  // 訓練実施要領コード：その他
  GUIDELINE_OTHER: '99',
  // 課題セレクトボックス：自対策本部内の課題
  TASK_JITAISAKUHONBU: '001',
  // 回答数の最小値
  REPLY_NUM_MIN: 1,
  // 理解度の最大値（文字）
  UNDERSTAND_MAX_STR: '3.0',
  // 理解度の最小値（文字）
  UNDERSTAND_MIN_STR: '1.0',
  // 理解度の最大値（数値）
  UNDERSTAND_MAX_NUM: 3,
  // 理解度の最小値（数値）
  UNDERSTAND_MIN_NUM: 1,
  // 有効性の最大値（文字）
  EFFECT_MAX_STR: '3.0',
  // 有効性の最小値（文字）
  EFFECT_MIN_STR: '1.0',
  // 有効性の最大値（数値）
  EFFECT_MAX_NUM: 3,
  // 有効性の最小値（数値）
  EFFECT_MIN_NUM: 1,
  // 全体の平均の文字色（青）の基準値
  GOOD_VAL: 2.7,
  // 全体の平均の文字色（黒）の基準値
  NORMAL_VAL: 2.3
});